import { render, staticRenderFns } from "./CreateMainInformation.vue?vue&type=template&id=2f7de996&scoped=true&"
import script from "./CreateMainInformation.vue?vue&type=script&lang=js&"
export * from "./CreateMainInformation.vue?vue&type=script&lang=js&"
import style0 from "./CreateMainInformation.vue?vue&type=style&index=0&id=2f7de996&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7de996",
  null
  
)

export default component.exports